import { render, staticRenderFns } from "./TopicDetails.vue?vue&type=template&id=151bbe28"
import script from "./TopicDetails.vue?vue&type=script&lang=js"
export * from "./TopicDetails.vue?vue&type=script&lang=js"
import style0 from "./TopicDetails.vue?vue&type=style&index=0&id=151bbe28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports